import axios from 'axios'

const instance = axios.create({
  baseURL: '/'
})

instance.defaults.headers.common['Accept'] = 'application/json'

instance.interceptors.request.use(
  async request => {
    const accessToken = localStorage.getItem('accessToken')

    request.headers['Authorization'] = `Bearer ${accessToken}`
    if (['put', 'post'].includes(request.method)) {
      request.headers['X-CSRF-Token'] = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content')
    }

    return request
  },
  error => {
    return Promise.reject(error)
  }
)

export default instance
